// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#app,\r\nbody,\r\nhtml {\r\n  width: 100%;\r\n  height: 100%;\r\n  font-size: 14px;\r\n  font-family: \"Helvetica Neue\",Helvetica,\"PingFang SC\",\"Hiragino Sans GB\",\"Microsoft YaHei\",\"微软雅黑\",Arial,sans-serif;\r\n  color: #474F64;\r\n  line-height: 1.5;\r\n  margin: 0;\r\n  padding: 0;\r\n  overflow: hidden;\n}\r\n", ""]);
// Exports
module.exports = exports;
